import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroImg from "@/assets/hero/zeefdruk.webp";
import procesZeefdruk from "@/assets/techniques/zeefdruk.webp";

const Zeefdrukkerij = () => (
  <PageLayout
    title="Zeefdrukkerij"
    metaDescription="Zeefdruk bij Magic Print Den Haag: betrouwbare druktechniek met hoge kleurechtheid en goed dekkende prints op T-shirts, hoodies, polo's en bedrijfskleding."
    ogImage={heroImg}
    hero={
      <PageHero
        image={heroImg}
        alt="Zeefdruk bij Magic Print"
        title="Uw zeefdrukkerij in de regio"
        subtitle="Betrouwbare druktechniek met hoge kleurechtheid en goed dekkende prints."
      />
    }
  >


    <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
      Zeefdruk is een populaire druktechniek waarmee vrijwel elk materiaal bedrukt kan worden, bijvoorbeeld papier, karton, canvas en textiel. Het is een betrouwbare methode met een hoge kleurechtheid. De te drukken print wordt met een vrij dikke laag inkt overgebracht op het textiel, waardoor de bedrukking van goede kwaliteit en goed dekkend is. Mede hierdoor wordt de uiteindelijke kleur niet beïnvloed door de kleur van de kleding. Zeefdruk is dus geschikt voor iedere kleur textiel.
    </p>

    <section className="mb-12 grid md:grid-cols-2 gap-8 items-center">
      <div>
        <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Wat is zeefdruk?</h2>
        <p className="text-muted-foreground mb-4">
          Hoe werkt zeefdruk? Het principe van zeefdruk is doordruk. Door middel van een zeef wordt de te drukken print op het textiel aangebracht. De zeef bestaat uit een stuk fijn gaas dat over een raamwerk is gespannen. Op de zeef wordt een sjabloon aangebracht met het beeld dat gedrukt moet worden. Het sjabloon bevat allemaal kleine gaatjes, daar waar de inkt doorgelaten moet worden.
        </p>
        <p className="text-muted-foreground">
          Wanneer de opdruk meerdere kleuren bevat, moet er voor iedere kleur een aparte zeef – ook wel film genoemd – gemaakt worden. Iedere kleur wordt afzonderlijk op het textiel aangebracht. De volgende kleur kan namelijk pas aangebracht worden nadat de eerste laag gedroogd is.
        </p>
      </div>
      <img
        src={procesZeefdruk}
        alt="Zeefdruk proces"
        loading="lazy"
        className="w-full h-auto rounded-2xl"
      />
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Zeefdruk kleding</h2>
      <p className="text-muted-foreground mb-4">
        Bij Magic Print kunt u verschillende soorten textiel laten bedrukken in onze zeefdrukkerij. Kledingsoorten die het meest geschikt zijn voor zeefdruk zijn onder andere t-shirts, hoodies en polo's. Maar ook voor het drukken van producten zoals bedrijfskleding, caps, jassen en sportkleding kunt u bij ons terecht.
      </p>
      <p className="text-muted-foreground">
        Alle producten van Magic Print zijn van zeer hoge kwaliteit en geschikt om te laten bedrukken. Houdt er bij zeefdruk rekening mee dat de producten vlak dienen te zijn om deze druktechniek te kunnen gebruiken. Voor caps en tassen raden wij een andere druktechniek aan — wij adviseren u graag over de verschillende mogelijkheden.
      </p>
    </section>

    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Kleding bedrukken bij Magic Print</h2>
      <p className="text-muted-foreground mb-6">
        Wilt u kleding laten bedrukken? Zeefdruk is een zeer geschikte methode voor het drukken van grotere bestellingen. Laat u adviseren over de verschillende mogelijkheden of vraag vrijblijvend een offerte aan. We leveren, bedrukken en borduren kleding in onze drukkerij in Den Haag. In de regio Den Haag bezorgen we gratis uw bestelling — uiteraard is het ook mogelijk om uw bestelling door heel Nederland te verzenden.
      </p>
      <Button asChild>
        <Link to="/offerte">Vraag een offerte aan</Link>
      </Button>
    </section>
  </PageLayout>
);

export default Zeefdrukkerij;
